export enum PriceBreakDownItemTypes {
  Product = 'Product',
  Service = 'Service',
}

export type PriceBreakdownData = {
  name: string;
  equipmentPrice: number;
  servicesPrice: number;
  tax?: number;
};

export type PriceBreakDownItemDictionary = {
  code: string;
  title: string;
  type: PriceBreakDownItemTypes;
  price: number;
};

export type PriceBreakDown = {
  items: PriceBreakDownItemDictionary[];
  tax: number | null;
};

export type Product = {
  id: string;
  name: string;
  portalName: string;
  price: string;
  minQuantity: number;
  discountAmount: number;
  quantityDiscountThreshold: number;
  deliveryDelayDays: number;
  isCustom: boolean;
  sortingOrder: number;
  isPreSelected: boolean;
  isAddOn: boolean | null;
};
